// extracted by mini-css-extract-plugin
export default {"mainBody":"MainBody_mainBody__iEYX6","topHeading":"MainBody_topHeading__pV4-g","middleHeading":"MainBody_middleHeading__z2-X2","exploreNow":"MainBody_exploreNow__R-Jy5"};